<policy-details-legacy *ngIf="isPolicyViewV2 === false"></policy-details-legacy>
<policy-details *ngIf="isPolicyViewV2"></policy-details>